module.exports = "data:image/vnd.microsoft.icon;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJtZWRpYS9kb3JtYWthYmEuaWNvIjs="